import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { History, ArrowRight } from "lucide-react";

const fmt = (iso) => (iso ? new Date(iso).toLocaleString("it-IT", { dateStyle: "short", timeStyle: "short" }) : "—");
const TIPO = { nuovo: "bg-emerald-100 text-emerald-700", rimosso: "bg-red-100 text-red-700", modificato: "bg-amber-100 text-amber-700" };

export function AbiConfronto({ id, version }) {
  const nav = useNavigate();
  const [c, setC] = useState(null);
  useEffect(() => { api.get(`/abi/analyses/${id}/confronto`).then(({ data }) => setC(data)).catch(() => {}); }, [id, version]);
  if (!c || (!c.confronto_disponibile && !(c.altre_analisi || []).length)) return null;

  return (
    <div className="rounded-xl border border-slate-200 bg-white p-5 mt-4" data-testid="abi-confronto">
      <div className="flex items-center gap-2 mb-1"><History className="h-4 w-4 text-violet-600" /><h3 className="font-heading font-semibold text-slate-800 text-sm">Cronologia e confronto</h3></div>
      {c.confronto_disponibile && (
        <>
          <p className="text-xs text-slate-500 mb-3" data-testid="abi-confronto-intestazione">
            Confronto con {c.confronto_con === "aggiornamento_precedente" ? "l'aggiornamento precedente" : "un'altra analisi dello stesso soggetto"} del {fmt(c.precedente_at)} → dati attuali del {fmt(c.attuale_at)}
          </p>
          {c.differenze.length === 0 ? (
            <p className="text-sm text-emerald-700" data-testid="abi-confronto-nessuna">Nessuna differenza: i dati sono invariati.</p>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full text-sm" data-testid="abi-confronto-tabella">
                <thead><tr className="text-left text-[11px] uppercase tracking-wide text-slate-400 border-b"><th className="py-1.5 pr-3">Dato</th><th className="py-1.5 pr-3">Prima</th><th className="py-1.5 pr-3">Ora</th><th className="py-1.5">Esito</th></tr></thead>
                <tbody>
                  {c.differenze.map((d, i) => (
                    <tr key={i} className="border-b border-slate-50 align-top" data-testid={`abi-confronto-riga-${i}`}>
                      <td className="py-1.5 pr-3 text-slate-600 min-w-[160px]">{d.campo}</td>
                      <td className="py-1.5 pr-3 text-slate-500 break-words max-w-[260px]">{d.prima ?? "—"}</td>
                      <td className="py-1.5 pr-3 text-slate-800 break-words max-w-[260px]">{d.dopo ?? "—"}</td>
                      <td className="py-1.5"><span className={`text-[10px] px-1.5 py-0.5 rounded ${TIPO[d.tipo]}`}>{d.tipo}</span></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </>
      )}
      {(c.altre_analisi || []).length > 0 && (
        <div className="mt-4 pt-3 border-t border-slate-100">
          <p className="text-[11px] uppercase tracking-wide text-slate-400 mb-1.5">Altre analisi dello stesso soggetto</p>
          <div className="flex flex-wrap gap-2">
            {c.altre_analisi.map((a) => (
              <button key={a.id} onClick={() => nav(`/business-intelligence/analisi/${a.id}`)} className="text-xs px-2.5 py-1 rounded-md border border-slate-200 hover:bg-slate-50 inline-flex items-center gap-1 transition-colors" data-testid={`abi-altra-analisi-${a.id}`}>
                {fmt(a.updated_at || a.created_at)} · {a.mode} <ArrowRight className="h-3 w-3" />
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
